export default "__VITE_ASSET__2e38a9dd__"